
//import {counter} from './components/counter.js';
export let pageSections = () => {

    // For page sections
    if(!$('body').hasClass('home')) {

        const sections = gsap.utils.toArray('.section:not(.section--disabled)');

        sections.forEach((section) => {

            const targets = section.querySelector('.section__content');
            
            const section_tl = gsap.timeline({
            scrollTrigger:{
                trigger: section,
                start: "top 80%",
                end: "bottom 80%"
                //markers: true
            }});
            if (targets !== null) {

                section_tl.from(targets.children, { y: '20%', stagger: 0.5, opacity: 0, duration:1, ease: 'power1.InOut', delay: 0 });

            }
        });

    }

}
